// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uI5F","toggle":"styles_toggle__2eHtT","preview":"styles_preview__3tPwD"};